const WORDS = ["Piscina aquecida", "Lareira", "Adega climatizada", "Fogo de chão", "Serra Negra · SP", "Hidromassagem", "Enxoval Trussardi"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#2c4a38] bg-[#163323] py-7">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`px-8 text-3xl font-bold uppercase tracking-tight sm:text-5xl ${i % 2 ? "text-outline" : "text-[#faf7f2]"}`}>{w}</span>
            <span className="h-2.5 w-2.5 rounded-full bg-[#c86d4b]" />
          </span>
        ))}
      </div>
    </div>
  );
}
